import { Navigate } from "react-router-dom";
import { useState, useEffect } from "react"
import { useDispatch, useSelector } from 'react-redux'

import { fetchApi } from '../tools' // Consumir api
import WarningModal from '../components-modals/WarningModal.js'

import { setCta } from '../../app/dashboardAlumnosSlice.js'

const VerificaSolvente = ({ Carnet, url, headers, solvente, children, ruta }) => {

    const dispatch = useDispatch()

    const dirWebApp = process.env.REACT_APP_DIR_PRO

    const [loading, setLoading] = useState(false)
    const [showAcceso, setShowAcceso] = useState(false)

    const fetchAccess = async () => {
        try {
            setLoading(true)
            const data = await fetchApi({
                url: url + '/perfilalumno/perfildeuda',
                headers,
                content: {
                    Carnet
                }
            })
            dispatch(setCta({ data }))
            setShowAcceso(true)
            setLoading(false)
        } catch (err) {
            console.log(err)
        }
    }

    useEffect(() => {
        if (solvente === 1) {
            fetchAccess()
        } else {
            setShowAcceso(true)
        }
    }, [])

    const rawDataCta = useSelector((state) => state.dashboardAlumno.dataCta)

    return (
        <>
            <WarningModal
                open={loading ? true : false}
                image={<img src='./img/loader.gif' alt='loading' />}
                opacity='bg-opacity-100'
            />
            {showAcceso && solvente === 1
                ? rawDataCta.deuda === 0
                    ? ruta === '/notas' && rawDataCta.BlokNotas === true
                        ? <Navigate to={`${dirWebApp}warning/Actualmente, no puedes acceder a tus notas académicas debido a una solicitud de Dirección.`} replace />
                        : children
                    : <Navigate to={`${dirWebApp}warning/Te invitamos a que realices tus pagos, para que puedas visualizar todo nuestro campus virtual.`} replace />
                : children
            }
        </>
    )
}

export default VerificaSolvente